import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, PhoneCall, Map } from 'lucide-react';
import { ServiceAreaMap } from './ServiceAreaMap';
const illinoisCities = ['Elgin', 'Barrington', 'Crystal Lake', 'McHenry', 'Libertyville', 'Gurnee', 'Lake Forest', 'Highland Park'];
const wisconsinCities = ['Lake Geneva', 'Fontana', 'Williams Bay'];
export function ServiceAreasSection() {
  return <section id="areas" className="py-24 bg-earth-900 text-cream-100 relative overflow-hidden" data-id="element-173">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#FAFAF5 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-174"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-175">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center mb-16" data-id="element-176">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="lg:col-span-5" data-id="element-177">
            <h2 className="text-sm font-bold tracking-widest text-forest-500 uppercase mb-3" data-id="element-178">
              Where We Work
            </h2>
            <h3 className="text-3xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-179">
              Illinois & Wisconsin
            </h3>
            <p className="text-xl text-cream-200/80 mb-8" data-id="element-180">
              We proudly serve communities across two states, offering reliable
              service with up to a 90-minute travel radius.
            </p>

            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6 flex items-start gap-4" data-id="element-181">
              <div className="bg-forest-500 rounded-full p-3 text-white shrink-0" data-id="element-182">
                <PhoneCall size={24} data-id="element-183" />
              </div>
              <div data-id="element-184">
                <h4 className="text-lg font-bold text-white mb-1" data-id="element-185">
                  Not on the list? Call anyway.
                </h4>
                <p className="text-cream-200/80" data-id="element-186">
                  We travel up to 90 minutes — your location is not a barrier.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-187">
            {/* Illinois Column */}
            <div className="bg-white rounded-2xl p-8 shadow-xl text-gray-800" data-id="element-188">
              <div className="flex items-center gap-3 mb-6 pb-4 border-b border-gray-100" data-id="element-189">
                <span className="text-2xl" data-id="element-190">🇺🇸</span>
                <h4 className="text-2xl font-heading font-bold text-earth-900" data-id="element-191">
                  Illinois
                </h4>
              </div>
              <ul className="space-y-3" data-id="element-192">
                {illinoisCities.map((city, idx) => <li key={idx} className="flex items-center gap-3" data-id="element-193">
                    <MapPin size={18} className="text-forest-500 shrink-0" data-id="element-194" />
                    <span className="font-medium" data-id="element-195">{city}</span>
                  </li>)}
              </ul>
            </div>

            {/* Wisconsin Column */}
            <div className="bg-white rounded-2xl p-8 shadow-xl text-gray-800" data-id="element-196">
              <div className="flex items-center gap-3 mb-6 pb-4 border-b border-gray-100" data-id="element-197">
                <span className="text-2xl" data-id="element-198">🌊</span>
                <h4 className="text-2xl font-heading font-bold text-earth-900" data-id="element-199">
                  Wisconsin
                </h4>
              </div>
              <ul className="space-y-3" data-id="element-200">
                {wisconsinCities.map((city, idx) => <li key={idx} className="flex items-center gap-3" data-id="element-201">
                    <MapPin size={18} className="text-forest-500 shrink-0" data-id="element-202" />
                    <span className="font-medium" data-id="element-203">{city}</span>
                  </li>)}
              </ul>
            </div>
          </motion.div>
        </div>

        {/* Map Section */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-12" data-id="element-204">
          <div className="flex items-center gap-3 mb-6" data-id="element-205">
            <Map className="text-forest-500" size={28} data-id="element-206" />
            <h3 className="text-2xl md:text-3xl font-heading font-bold text-white" data-id="element-207">
              Interactive Coverage Map
            </h3>
          </div>
          <ServiceAreaMap data-id="element-208" />
        </motion.div>
      </div>
    </section>;
}